import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ui } from 'components';

import 'assets/screens.scss';
import './style.scss';

const CartScene = ({
  cart,
  deleteProduct,
  addProduct,
  removeCart,
  history: {
    push,
  },
}) => (
	<div className="cart-layout">
    <h1 className="cart-layout__caption">Ваша корзина</h1>
    {cart.quantity ?
      <ui.CartTable
        cart={cart}
        deleteProduct={deleteProduct}
        addProduct={addProduct}
        removeCart={removeCart}
        goToCheckout={() => push('/checkout')}
      />
      : <div className="cart-layout__empty-message">Ваша корзина пуста <br /> <Link to="/catalog">Перейти в магазин</Link></div>
    }
	</div>
);

CartScene.propTypes = {
  deleteProduct: PropTypes.func.isRequired,
  addProduct: PropTypes.func.isRequired,
  removeCart: PropTypes.func.isRequired,

  cart: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    sum: PropTypes.number.isRequired,
  }).isRequired,

  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default CartScene;



// WEBPACK FOOTER //
// ./src/scenes/CartScene/index.js